export default __webpack_public_path__ + "static/media/knife.86494d14.svg";